export const NOTIFICATION_API_PREFIX = '/message-management/um/recipients';
